// src/components/NavSuperior.jsx
import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import logo from '../../Assets/azul.png'; // Ruta correcta
import { useNavigate } from 'react-router-dom';
const NavSuperior = () => {
      const navigate = useNavigate();
  return (
    <AppBar position="static" sx={{ backgroundColor: '#06437c', boxShadow: 3 }}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'center', // ⬅️ Centra el contenido horizontalmente
          alignItems: 'center',
          textAlign: 'center',
          flexDirection: 'column', // ⬅️ Logo y texto uno debajo del otro (opcional)
          py: 1,
        }}
      >
        <Box component="img" src={logo} alt="Logo" sx={{ height: 60, mb: 0.5 }}  onClick={() => navigate('/')} />
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold', color: 'white' }}
        >
 
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default NavSuperior;
